<script>
    import {Link} from "svelte-routing";
</script>

<div class="error-page">
    <h1 class="title">Загрузка..</h1>
    <div class="text mb-5">
        Пожалуйста, подождите.
    </div>
    
    <div class="fixed-footer">
        <div class="row">
            <div class="col-12">
                <Link to="/" class="btn btn-primary btn-lg btn-block">Вернуться назад</Link>
            </div>
        </div>
    </div>
</div>
